const linkToggled = "linkToggled";
const linkedTravelUpdated = "linkedTravelUpdated";

export type LinkType = "train" | "groundTransport" | "flight";

export const onLinkToggled = (callback: (unlinkType: LinkType, id: number) => any) => {
  const onUnlinkCallback = (event: CustomEvent) => {
    callback(event.detail.type, event.detail.id);
  };
  document.addEventListener(linkToggled, onUnlinkCallback);

  return () => {
    document.removeEventListener(linkToggled, onUnlinkCallback);
  };
};

export const fireLinkToggleEvent = (unlinkType: LinkType, id: number) => {
  const ev = new CustomEvent(linkToggled, {
    detail: {
      type: unlinkType,
      id
    }
  });

  document.dispatchEvent(ev);
};

export const fireLinkedTravelUpdated = (linkedTravel: server.dto.LinkedTravel) => {
  const ev = new CustomEvent(linkedTravelUpdated, {
    detail: linkedTravel
  });
  document.dispatchEvent(ev);
};

export const onLinkedTravelUpdated = (callback: (linkedTravel: server.dto.LinkedTravel) => any) => {
  const onLinkedTravelUpdatedCallback = (event: CustomEvent) => {
    callback(event.detail);
  };
  document.addEventListener(linkedTravelUpdated, onLinkedTravelUpdatedCallback);

  return () => {
    document.removeEventListener(linkedTravelUpdated, onLinkedTravelUpdatedCallback);
  };
};
